import TeamLogo from "../../../img/team-logos/black-background-logo.png";

import AerodynamicsImage from "../../../img/design_page/Aerodynamics_Image.JPG";
import AerodynamicsCover from "../../../img/design_page/Aerodynamics_Cover.jpg";

import BrakesImage from "../../../img/design_page/Brakes_Image.JPG";
import BrakesCover from "../../../img/design_page/Brakes_Cover.jpg";

import BusinessImage from "../../../img/design_page/Business_Image.png";
import BusinessCover from "../../../img/design_page/Business_Cover.jpg";

import ChassisImage from "../../../img/design_page/Chassis_Image.jpg";
import ChassisCover from "../../../img/design_page/Chassis_Cover.PNG";

import CompositesImage from "../../../img/design_page/Composites_Image.jpg";
import CompositesCover from "../../../img/design_page/Composites_Cover.jpg";

import ControlsImage from "../../../img/design_page/Controls_Image.png";
import ControlsCover from "../../../img/design_page/Controls_Cover.png";

import DrivetrainImage from "../../../img/design_page/Drivetrain_Image.jpg";
import DrivetrainCover from "../../../img/design_page/Drivetrain_Cover.png";

import ErgonomicsImage from "../../../img/design_page/Ergonomics_Image.jpg";
import ErgonomicsCover from "../../../img/design_page/Ergonomics_Cover.jpg";

import SuspensionImage from "../../../img/design_page/Suspension_Image.png";
import SuspensionCover from "../../../img/design_page/Suspension_Cover.png";

import LowHighVoltageImage from "../../../img/design_page/Low-HighVoltage_Image.png";
import LowHighVoltageCover from "../../../img/design_page/Low-HighVoltage_Cover.png";


const designTeams = [

  // left column of the car image

  {
    id: "aerodynamics",
    hotspot: {
      top: "16%",
      left: "24%",
      width: "14%",
      height: "8%",
    },
    modal: {
      title: "Aerodynamics",
      subtitle: "Downforce, drag reduction, and aerodynamic package design.",
      images: [AerodynamicsImage, AerodynamicsCover],
      tabs: {
        overview: {
          label: "Overview",
          description: "The Aerodynamics and Cooling sub-team is responsible for the design, analysis, testing, and validation of the vehicle's aerodynamic package, which includes the front wing, rear wing, nosecone, and radiator ducts. The downforce creation and drag reduction provided by these components are integral to the vehicle's performance on the track, aiming to reduce lap times by improving handling, traction, and overall efficiency.",
          bullets: [],
        },
        whatWeDo: {
          label: "What We Do",
          description: "The team collaborates with suspension, steering, and cooling sub-teams to integrate airflow and vehicle dynamics considerations across the full car.",
          bullets: [
            "Front wing, rear wing, nosecone, and radiator duct design.",
            "2D and 3D CFD simulation and FEA analysis.",
            "Mechanical design and modelling of aerodynamic components.",
            "Collaboration with suspension, steering, and cooling teams.",
          ],
        },
        team: {
          label: "Team",
          description: "Members develop skills across research, analysis, mechanical design, and simulation. The sub-team places emphasis on building from first principles and iterating toward an optimized solution, giving members experience with the full engineering process from concept through to validation.",
          bullets: [],
        },
      },
    },
  },

  {
    id: "vehicle-dynamics",
    hotspot: {
      top: "27.5%",
      left: "18.25%",
      width: "16%",
      height: "8%",
    },
    modal: {
      title: "Vehicle Dynamics",
      subtitle: "Full-vehicle simulation, tire dynamics, and chassis tuning.",
      images: [TeamLogo],
      tabs: {
        overview: {
          label: "Overview",
          description: "The Vehicle Dynamics team builds and simulates full vehicle models to study response and maximize performance. We focus on preparing simulations that best represent our driving characteristics, validating decisions through data acquired during both static and dynamic testing.",
          bullets: [],
        },
        whatWeDo: {
          label: "What We Do",
          description: "The team is heavily involved in determining suspension and steering hardpoints to align with vehicle goals, and focuses on tire dynamics, chassis stiffness, and mass distribution across the full vehicle.",
          bullets: [
            "Full vehicle simulation and modeling.",
            "Suspension and steering hardpoint determination.",
            "Tire dynamics, chassis stiffness, and mass distribution analysis.",
            "Test plan preparation and vehicle parameter tuning for dynamic events.",
          ],
        },
        team: {
          label: "Team",
          description: "The team prepares test plans and tunes overall vehicle parameters to validate design decisions during dynamic testing scenarios, ultimately working toward the optimal track-ready setup each season.",
          bullets: [],
        },
      },
    },
  },

  {
    id: "suspension-structures",
    hotspot: {
      top: "40.5%",
      left: "15.5%",
      width: "19.5%",
      height: "8%",
    },
    modal: {
      title: "Suspension Structures",
      subtitle: "Suspension geometry, steering design, and vehicle handling.",
      images: [SuspensionImage, SuspensionCover],
      tabs: {
        overview: {
          label: "Overview",
          description: "The Steering and Suspension team is responsible for the design, manufacture, testing, and validation of functional steering and suspension systems for Mac Formula cars. We create vehicle dynamics models and analyze them using first-principles to define the handling behaviour we want the car to exhibit across racing scenarios including acceleration, braking, and cornering.",
          bullets: [],
        },
        whatWeDo: {
          label: "What We Do",
          description: "From our models, we design the parts that deliver our target handling: uprights, wishbones, bellcranks, and the steering system, while ensuring each component exceeds its expected load cases.",
          bullets: [
            "Upright, wishbone, bellcrank, and steering component design.",
            "Z-bar anti-roll bar integration for roll mitigation in corners.",
            "Suspension geometry optimisation for target handling goals.",
            "FEA validation against expected load cases.",
          ],
        },
        team: {
          label: "Team",
          description: "Our team is truly a multi-disciplinary one, with members working on projects that incorporate vehicle dynamics, mechanical design, dynamic simulations, FEA analysis, manufacturing, and more.",
          bullets: [],
        },
      },
    },
  },

  {
    id: "firmware-and-controls",
    hotspot: {
      top: "52%",
      left: "15.5%",
      width: "19%",
      height: "8%",
    },
    modal: {
      title: "Firmware and Controls",
      subtitle: "Vehicle control software, firmware, and real-time systems.",
      images: [ControlsImage, ControlsCover],
      tabs: {
        overview: {
          label: "Overview",
          description: "The Controls Sub-Team develops and designs the vehicle's control system software, managing tasks like the vehicle startup sequence, enabling high voltage power, processing driver inputs, and monitoring signals in real-time. The control system receives analog and digital signals from multiple ECUs and communicates across the vehicle's CAN bus.",
          bullets: [],
        },
        whatWeDo: {
          label: "What We Do",
          description: "During development, the team uses a real-time target machine like the SpeedGoat to rapidly test and prototype models, simulating CAN data and I/O signals. Each year the team refines and adds new features to the control system.",
          bullets: [
            "Vehicle startup sequence and high-voltage contactor control.",
            "Real-time signal processing and CAN bus communication.",
            "SpeedGoat rapid prototyping and hardware-in-the-loop testing.",
            "Torque vectoring and control system development in MATLAB, Simulink, and StateFlow.",
          ],
        },
        team: {
          label: "Team",
          description: "Members develop hands-on skills in MATLAB, Simulink, and StateFlow, gaining experience with real-time systems and iterative software development. Each season brings new features and refinements to the control stack, giving members the opportunity to build on previous work and push the system further.",
          bullets: [],
        },
      },
    },
  },

  {
    id: "wire-harness",
    hotspot: {
      top: "64%",
      left: "18.5%",
      width: "12.5%",
      height: "8%",
    },
    modal: {
      title: "Wire Harness",
      subtitle: "Harness design, manufacturing, and electrical integration.",
      images: [TeamLogo],
      tabs: {
        overview: {
          label: "Overview",
          description: "The Wire Harness sub-team is responsible for the design, build, and test of the vehicle's wire harness. This includes careful consideration of component selection, detailed documentation, CAD implementation, in-house manufacturing of the LV harness, and integration testing with the greater electrical system.",
          bullets: [],
        },
        whatWeDo: {
          label: "What We Do",
          description: "The team oversees the design of hardware projects to support the vehicle, and works carefully to ensure every component is correctly provisioned.",
          bullets: [
            "Component selection and detailed harness documentation.",
            "CAD implementation of harness routing throughout the vehicle.",
            "In-house manufacturing of the LV harness.",
            "Integration testing with the full electrical system.",
          ],
        },
        team: {
          label: "Team",
          description: "Members gain broad exposure across mechanical, electrical, and firmware disciplines through close collaboration with teams across the vehicle. Working on documentation, CAD, manufacturing, and testing provides a well-rounded engineering skillset.",
          bullets: [],
        },
      },
    },
  },

  {
    id: "drivetrain",
    hotspot: {
      top: "76%",
      left: "18.5%",
      width: "11%",
      height: "8%",
    },
    modal: {
      title: "Drivetrain",
      subtitle: "Gearboxes, wheel speed sensing, and drivetrain integration.",
      images: [DrivetrainImage, DrivetrainCover],
      tabs: {
        overview: {
          label: "Overview",
          description: "The Drivetrain sub-team is responsible for the design, validation, and assembly of the vehicle's drivetrain subsystems. The team's main focus is the two in-hub gearboxes at the rear of the vehicle, which form a vital link between the motors and the wheels.",
          bullets: [],
        },
        whatWeDo: {
          label: "What We Do",
          description: "Each season the team develops the housings, spindles, and gears, working closely with suspension and brakes to create a compact, well-integrated package. The team also collaborates with software and electrical members on vehicle sensing systems.",
          bullets: [
            "In-hub gearbox housing, spindle, and gear design.",
            "Gearbox size reduction and advanced simulation modelling.",
            "Cross-team integration with suspension and brakes.",
            "Front wheel speed measurement system for torque vectoring.",
          ],
        },
        team: {
          label: "Team",
          description: "Members gain experience with mechanical design, simulation modelling, and cross-functional engineering. Working alongside suspension, brakes, software, and electrical teams gives members exposure to how drivetrain decisions ripple across the broader vehicle.",
          bullets: [],
        },
      },
    },
  },

  {
    id: "brakes",
    hotspot: {
      top: "87.5%",
      left: "27%",
      width: "8%",
      height: "8%",
    },
    modal: {
      title: "Brakes",
      subtitle: "Braking system, pedal assembly, and rotor design.",
      images: [BrakesImage, BrakesCover],
      tabs: {
        overview: {
          label: "Overview",
          description: "The Brakes and Pedal Tray sub-team covers the entire braking system, from the brake pedal assembly and master cylinders through the brake lines to the rotors and calipers. The team also designs the accelerator pedal assembly with an adjustable pedal tray. Braking as late as possible over the minimum distance is a fundamental aspect of racing performance.",
          bullets: [],
        },
        whatWeDo: {
          label: "What We Do",
          description: "The team works closely with drivetrain and suspension to ensure fitment around the brake rotors, and partners with ergonomics to reflect driver needs in the pedal assemblies.",
          bullets: [
            "Brake pedal assembly, master cylinder, and caliper design.",
            "Adjustable accelerator pedal tray design.",
            "Thermal and structural simulation of brake rotors.",
            "Collaboration with drivetrain, suspension, and ergonomics teams.",
          ],
        },
        team: {
          label: "Team",
          description: "Members gain practical experience across the full engineering process, from system design and simulation through to cross-team integration. Ongoing work on pedal ratio improvement and rotor simulation gives members direct exposure to performance-driven design iteration.",
          bullets: [],
        },
      },
    },
  },

  // bottom row of the car image

  {
    id: "chassis",
    hotspot: {
      top: "92%",
      left: "38%",
      width: "10%",
      height: "8%",
    },
    modal: {
      title: "Chassis",
      subtitle: "Carbon fibre chassis, roll hoops, and structural components.",
      images: [ChassisImage, ChassisCover],
      tabs: {
        overview: {
          label: "Overview",
          description: "The Chassis sub-team is responsible for designing and validating the carbon fibre chassis, roll hoops, impact attenuator, firewall, and jack bar. These parts play a critical role in the functioning of the car and account for most of the manufacturing effort and time each season.",
          bullets: [],
        },
        whatWeDo: {
          label: "What We Do",
          description: "With a strong focus on design for assembly, the team works closely with machining and composites to ensure every design is feasible to manufacture.",
          bullets: [
            "Carbon fibre chassis and roll hoop design and validation.",
            "Impact attenuator, firewall, and jack bar design.",
            "Design for assembly with machining and composites input.",
            "Detailed engineering drawing preparation for manufacturing.",
          ],
        },
        team: {
          label: "Team",
          description: "Members develop skills in structural design and validation, engineering drawing preparation, and design for assembly. Close collaboration with the machining and composites sub-teams gives members experience translating design decisions into manufacturable parts.",
          bullets: [],
        },
      },
    },
  },

  {
    id: "composites",
    hotspot: {
      top: "91%",
      left: "63.5%",
      width: "12%",
      height: "8%",
    },
    modal: {
      title: "Composites",
      subtitle: "In-house manufacturing of carbon fibre and composite parts.",
      images: [CompositesImage, CompositesCover],
      tabs: {
        overview: {
          label: "Overview",
          description: "The Composites sub-team works closely with Machining to complete all in-house manufacturing tasks. The team manufactures the monocoque, airfoils, nosecone, bucket seat, firewall, and all other carbon fibre, Kevlar, and fiberglass parts.",
          bullets: [],
        },
        whatWeDo: {
          label: "What We Do",
          description: "Parts are designed and manufactured to be as lightweight as possible while meeting their specific loading conditions. The team conducts material tests to determine the most optimal composite layups for each application.",
          bullets: [
            "Monocoque, airfoils, nosecone, and bucket seat manufacturing.",
            "Carbon fibre, Kevlar, and fiberglass layup work.",
            "Material testing for composite layup optimisation.",
            "Weight minimisation while satisfying structural requirements.",
          ],
        },
        team: {
          label: "Team",
          description: "Members develop hands-on experience with composite manufacturing processes, including layup work and material testing. Testing parts to understand failure modes builds practical engineering intuition that spans design, manufacturing, and structural analysis.",
          bullets: [],
        },
      },
    },
  },

  // right column of the car image

  {
    id: "ergonomics",
    hotspot: {
      top: "25%",
      left: "81%",
      width: "13%",
      height: "8%",
    },
    modal: {
      title: "Ergonomics",
      subtitle: "Driver interaction, cockpit design, and human factors.",
      images: [ErgonomicsImage, ErgonomicsCover],
      tabs: {
        overview: {
          label: "Overview",
          description: "The Human Factors and Ergonomics sub-team is responsible for all components of the car that interact with the driver, ranging from the steering wheel grips to all necessary driver equipment. Every design must accommodate bodies from the 5th percentile female to the 95th percentile male.",
          bullets: [],
        },
        whatWeDo: {
          label: "What We Do",
          description: "The sub-team designs components that spatially fit within the cockpit and abide by all safety protocols, with driver comfort, visibility, and ease of control as the core priorities.",
          bullets: [
            "Steering wheel, grips, and driver equipment design.",
            "Cockpit packaging within safety protocol constraints.",
            "Driver sizing from 5th percentile female to 95th percentile male.",
            "Collaboration with brakes, aerodynamics, and suspension teams.",
          ],
        },
        team: {
          label: "Team",
          description: "Members work across a wide scope of components and gain experience designing for human factors, safety regulations, and cockpit packaging. The breadth of driver-interface work and close collaboration with multiple sub-teams gives members exposure to diverse engineering challenges each season.",
          bullets: [],
        },
      },
    },
  },

  {
    id: "powertrain-electrical",
    hotspot: {
      top: "39%",
      left: "84%",
      width: "20%",
      height: "8%",
    },
    modal: {
      title: "Powertrain Electrical",
      subtitle: "Battery enclosure design, packaging, and electromechanical integration.",
      images: [TeamLogo],
      tabs: {
        overview: {
          label: "Overview",
          description: "The Powertrain Electrical sub-team designs the enclosure for the energy storage system of the car that delivers high current to the motors during acceleration and driving. The objective of this enclosure is to protect the battery from the outside environment, allow for safe and convenient access to its electronics, while minimizing both weight and cost, and maximizing packaging efficiency.",
          bullets: [],
        },
        whatWeDo: {
          label: "What We Do",
          description: "The team works closely with the electrical sub-team for safety and assembly considerations, and with the chassis sub-team on the accumulator's mounting position, which determines the center of mass of the car.",
          bullets: [
            "Accumulator enclosure design and internal layout.",
            "Safe mounting, access, and maintainability design.",
            "Coordination with electrical for safety and assembly.",
            "Packaging decisions with chassis to optimize center of mass.",
          ],
        },
        team: {
          label: "Team",
          description: "Members learn electromechanical integration strategies and how to apply them while optimizing weight, cost, and packaging efficiency across a high-stakes vehicle system.",
          bullets: [],
        },
      },
    },
  },

  {
    id: "powertrain-mechanical",
    hotspot: {
      top: "52%",
      left: "85.5%",
      width: "21%",
      height: "8%",
    },
    modal: {
      title: "Powertrain Mechanical",
      subtitle: "",
      images: [TeamLogo],
      tabs: {
        overview: {
          label: "Overview",
          description: "", // fill in description
          bullets: [],
        },
        whatWeDo: {
          label: "What We Do",
          description: "",
          bullets: [],
        },
        team: {
          label: "Team",
          description: "",
          bullets: [],
        },
      },
    },
  },

  {
    id: "hv-electronics",
    hotspot: {
      top: "64%",
      left: "82%",
      width: "15%",
      height: "8%",
    },
    modal: {
      title: "HV Electronics",
      subtitle: "High-voltage PCB design, power management, and safety systems.",
      images: [LowHighVoltageImage, LowHighVoltageCover],
      tabs: {
        overview: {
          label: "Overview",
          description: "The High Voltage sub-team is responsible for controllers including the HV DCDC, HV controller, thermal monitoring system, and charger board. These boards manage and convert power from the high-voltage battery pack to supply the vehicle's systems, handling efficient power distribution and critical safety functions.",
          bullets: [],
        },
        whatWeDo: {
          label: "What We Do",
          description: "The team designs boards in Altium Designer, modifying and expanding them each year. Manufacturing and testing requires precise soldering and thorough debugging.",
          bullets: [
            "HV DCDC, HV controller, and thermal monitoring system design.",
            "Charger board development and validation.",
            "PCB design in Altium Designer.",
            "Board manufacturing, soldering, and debugging.",
          ],
        },
        team: {
          label: "Team",
          description: "Manufacturing and testing these boards is a demanding process that requires precise soldering and careful debugging. Members develop strong hands-on electrical engineering skills and gain experience iterating on complex high-voltage systems each season.",
          bullets: [],
        },
      },
    },
  },

  {
    id: "lv-electronics",
    hotspot: {
      top: "75%",
      left: "80%",
      width: "14.5%",
      height: "8%",
    },
    modal: {
      title: "LV Electronics",
      subtitle: "Low-voltage controllers, microcontrollers, and vehicle communication.",
      images: [LowHighVoltageImage, LowHighVoltageCover],
      tabs: {
        overview: {
          label: "Overview",
          description: "The Low Voltage sub-team specializes in designing and manufacturing in-house controllers as Printed Circuit Boards (PCBs). The most critical boards are the Front controller and LV controller, both equipped with STM32 microcontrollers.",
          bullets: [],
        },
        whatWeDo: {
          label: "What We Do",
          description: "These boards handle the vehicle's controls algorithm, startup sequences, sensor inputs, safety systems, and CAN bus communication, ensuring safe and efficient operation in compliance with Formula SAE regulations.",
          bullets: [
            "Front controller and LV controller design.",
            "STM32 microcontroller firmware development.",
            "Startup sequences, sensor inputs, and safety system logic.",
            "CAN bus and inter-ECU communication.",
          ],
        },
        team: {
          label: "Team",
          description: "Manufacturing and testing these boards is a demanding process that requires precise soldering and careful debugging. Members develop strong hands-on electrical engineering skills and gain experience iterating on complex low-voltage systems each season.",
          bullets: [],
        },
      },
    },
  },

  {
    id: "business",
    hotspot: {
      top: "89%",
      left: "79.5%",
      width: "10%",
      height: "8%",
    },
    modal: {
      title: "Business",
      subtitle: "Marketing, sponsorships, and team outreach.",
      images: [BusinessImage, BusinessCover],
      tabs: {
        overview: {
          label: "Overview",
          description: "The Business sub-team oversees the team's marketing and sponsorships. Marketing tasks include creating social media content and designing team merchandise, while sponsorship outreach is essential for securing the resources the team needs to compete each year.",
          bullets: [],
        },
        whatWeDo: {
          label: "What We Do",
          description: "Members work closely with other sub-teams to identify areas that most require sponsor support, and are responsible for reaching out to and managing relationships with potential sponsors.",
          bullets: [
            "Social media content creation and team merchandise design.",
            "Sponsor outreach and relationship management.",
            "Collaboration with sub-teams to identify funding priorities.",
            "Building and maintaining sponsor connections year over year.",
          ],
        },
        team: {
          label: "Team",
          description: "The Business sub-team has established connections with numerous sponsors over the past year, enabling MAC Formula Electric to function as one cohesive unit. Members develop skills in communication, marketing, and professional outreach that extend well beyond the team.",
          bullets: [],
        },
      },
    },
  },

];

export default designTeams;